export default __webpack_public_path__ + "alberta-next-visit-delete.d31001c152a2bedd7347.svg";